import script from "./GoogleLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./GoogleLogin.vue?vue&type=script&setup=true&lang=js"

import "./GoogleLogin.vue?vue&type=style&index=0&id=17471f8e&lang=css"

const __exports__ = script;

export default __exports__